import type { RouteRecordRaw } from "vue-router";

/**
 * Each page names the right that gates it and the guard in router/index.ts resolves it, matching how the
 * account and purchases routes declare theirs. The Oil & Energy group itself is gated on the customer being
 * flagged as Oil & Energy in Merchant, which OilEnergySecuritySettings folds into every page's own right.
 */
const oilEnergyMenuRoutes: RouteRecordRaw[] = [
  {
    path: "/oilEnergy/tanks",
    name: "view-tanks",
    component: () => import("@/views/OilEnergy/ViewTanks.vue"),
    meta: {
      title: "Tank Information",
      requiresAuth: true,
      oilEnergyPermission: "tanks",
    },
  },
  {
    path: "/oilEnergy/delivery",
    name: "view-oil-energy-delivery",
    component: () => import("@/views/OilEnergy/ViewDelivery.vue"),
    meta: {
      title: "Delivery",
      requiresAuth: true,
      oilEnergyPermission: "delivery",
    },
  },
  {
    path: "/oilEnergy/budgetBilling",
    name: "view-budget-billing",
    component: () => import("@/views/OilEnergy/ViewBudgetBilling.vue"),
    meta: {
      title: "Budget Billing",
      requiresAuth: true,
      oilEnergyPermission: "budgetBilling",
    },
  },
  {
    path: "/oilEnergy/leaseAgreements",
    name: "view-lease-agreements",
    component: () => import("@/views/OilEnergy/ViewLeaseAgreements.vue"),
    meta: {
      title: "Lease Agreements",
      requiresAuth: true,
      oilEnergyPermission: "leaseAgreements",
    },
  },
  {
    path: "/oilEnergy/energyAssistance",
    name: "view-energy-assistance",
    component: () => import("@/views/OilEnergy/ViewEnergyAssistance.vue"),
    meta: {
      title: "Energy Assistance",
      requiresAuth: true,
      oilEnergyPermission: "energyAssistance",
    },
  },
  {
    path: "/oilEnergy/salesContracts",
    name: "view-sales-contracts",
    component: () => import("@/views/OilEnergy/ViewSalesContracts.vue"),
    meta: {
      title: "Sales Contracts",
      requiresAuth: true,
      oilEnergyPermission: "salesContracts",
    },
  },
];

export default oilEnergyMenuRoutes;
